module.exports = __webpack_public_path__ + "img/online_giving.531dc1cf.png";